import axios from "axios";
import { store } from "../store/Store";
const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
// console.log("base url", BASEURL);
const axiosInHealth = axios.create({
  baseURL: BASEURL,
});
axiosInHealth.interceptors.request.use((config) => {
  const auth = store.getState().healthdetail?.healthnum;
  //console.log(auth);
  const token = auth?.token;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  return config;
});

export default axiosInHealth;
